import CrmLayout from "../../Views/Crm/Layout";
import CrmOfficeIndex from '../../Views/Crm/Office/Index';
import CrmOfficeLayout from '../../Views/Crm/Office/Layout';
import CrmGroupsLayout from '../../Views/Crm/Groups/Layout';
import CrmGroupsIndex from '../../Views/Crm/Groups/Index';
import CrmGroupsShow from '../../Views/Crm/Groups/Show';
import CrmGroupsForm from '../../Views/Crm/Groups/Form';
import SocialUserProfile from '../../Views/Social/UserProfile';

// Companies
import CrmCompaniesLayout from '../../Views/Crm/Companies/Layout';
import CrmCompaniesIndex from '../../Views/Crm/Companies/Index';
import CrmCompaniesShow from '../../Views/Crm/Companies/Show';
import CrmCompaniesForm from '../../Views/Crm/Companies/Form';

// Contacts
import CrmContactsLayout from '../../Views/Crm/Contacts/Layout';
import CrmContactsIndex from '../../Views/Crm/Contacts/Index';
import CrmContactsShow from '../../Views/Crm/Contacts/Show';
import CrmContactsForm from '../../Views/Crm/Contacts/Form';

export default [
    {
        path:'/crm',
        redirect:'/crm/contacts',
        name:'crm.index',
        component:CrmLayout,
        children:[
            {
                path:'contacts',
                component:CrmContactsIndex,
                name:'crm.contacts.index',
            },
            {
                path:'contacts/add',
                component:CrmContactsForm,
                name:'crm.contacts.add',
            },
            {
                path:'contacts/:uuid',
                component:CrmContactsLayout,
                children:[
                    {
                        path:'',
                        component:CrmContactsShow,
                        name:'crm.contacts.show',
                    },
                    {
                        path:'edit',
                        component:CrmContactsForm,
                        name:'crm.contacts.edit',
                    },
                ]
            },
            {
                path:'companies',
                component:CrmCompaniesIndex,
                name:'crm.companies.index',
            },
            {
                path:'companies/add',
                component:CrmCompaniesForm,
                name:'crm.companies.add',
            },
            {
                path:'companies/:uuid',
                component:CrmCompaniesLayout,
                children:[
                    {
                        path:'',
                        component:CrmCompaniesShow,
                        name:'crm.companies.show',
                    },
                    {
                        path:'edit',
                        component:CrmCompaniesForm,
                        name:'crm.companies.edit',
                    },
                ]
            },
            {
                path:'office',
                component: CrmOfficeLayout,
                children: [
                    {
                        path: '',
                        component: CrmOfficeIndex,
                        name: 'crm.office.index',
                    },
                    {
                        path: ':uuid',
                        component: SocialUserProfile,
                        name:'crm.office.show',
                    },
                ],
            },
            {
                path:'groups',
                component:CrmGroupsLayout,
                children:[
                    {
                        path:'',
                        name:'crm.groups.index',
                        component:CrmGroupsIndex,
                    },
                    {
                        path:'add',
                        name:'crm.groups.add',
                        component:CrmGroupsForm,
                    },
                    {
                        path:':uuid',
                        name:'crm.groups.show',
                        component:CrmGroupsShow,
                    },
                    {
                        path:':uuid/edit',
                        name:'crm.groups.edit',
                        component:CrmGroupsForm,
                    },
                ],
            },
        ]
    },
];
